export enum ZIndex {
  MIN = 1,
  BELOW = 100,
  NORMAL = 200,
  TOP = 300,
  OVERLAY = 400,
  DESKTOP_HEADER = 500,
  MAX = 999900,
}

export enum LayoutWidth {
  SMALL = 600,
  REGULAR = 1200,
}
